<template>
  <div class="container">
    <div class="top_title">
      <!-- 返回按钮 -->
      <!--      <router-link class="icon_back" :to="{ name: 'H600030' }" tag="span"></router-link>-->
      <span>课时余额查询结果</span>
    </div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="weui-cells item" style="border: 0 !important; margin-top: 2.4rem">

        <div class="weui-cell" v-for="(item,index) in dataList" :key="index">
          <div class="weui-cell__bd">
            <p>{{ item.I_TEXT }}</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" :disabled="true" class="input_text" v-model="item.I_VALUE"
                   style="padding-right: 0.4rem;color: #000;opacity: 1;"/>
          </div>
        </div>

      </div>
      <div style="font-size: 0.8rem;color: rgb(128, 128, 132);text-align: center;margin-top: 0.5rem">
        ※课时消耗与录入校区系统的实时性有关，以上结果仅供参考，具体课时余额以校区正式回复为准。
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import dataRequestFactory from "../factories/dataRequestFactory";

export default {
  data() {
    return {
      I_SCHOOL_VALUE: '',
      I_TEL: '',
      dataList: []
    }
  },
  methods: {},
  mounted() {
    var win_h = $(window).height();  //关键代码
    $("body").height(win_h);  //关键代码

    let params = this.$route.params

    if (params.I_SCHOOL_NO) {
      this.I_SCHOOL_VALUE = params.I_SCHOOL_NO
    }

    if (params.I_PHONE) {
      this.I_TEL = params.I_PHONE
    }

    let requestParams = {
      "I_SCHOOL_NO": this.I_SCHOOL_VALUE,
      "I_PHONE": this.I_TEL,
    }

    dataRequestFactory.I700020(requestParams).then(res => {
      if (res.resultCode === '0') {
        this.dataList = res.DataList
      } else {
        weui.topTips(response.errorDesc);
      }
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/H700020.vue